import React from 'react'
import Index from '../_components/Simulation/Index'

const Simulation = () => {
  return (
    <Index />
  )
}

export default Simulation
